<script>
  import { onMount } from "svelte";

  onMount(() => {
    if (!confetti) return;

    function randomInRange(min, max) {
      return Math.random() * (max - min) + min;
    }

    let animationEnd = Date.now() + 5 * 1000;
    let interval = setInterval(function () {
      if (animationEnd - Date.now() <= 0) return clearInterval(interval);

      confetti({
        origin: { x: randomInRange(0.3, 0.7), y: randomInRange(0.3, 0.4) },
        particleCount: 100,
        spread: 70,
      });
    }, 500);
  });
</script>

<svelte:head>
  <script
    src="https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.3/dist/confetti.browser.min.js"
  >
  </script>
</svelte:head>
